import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { Search as SearchIcon } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!query) {
        setProducts([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/api/search?q=${encodeURIComponent(query)}`);
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error('Arama hatası:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [query]);

  const handleAddToCart = (product) => {
    setCart([...cart, product]);
    alert(`${product.name} sepete eklendi!`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header cartCount={cart.length} />

      <div className="container mx-auto px-4 py-8">
        {/* Search Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <SearchIcon size={32} className="text-red-600" />
            <h1 className="text-3xl font-bold text-gray-800">Arama Sonuçları</h1>
          </div>
          
          {query && (
            <p className="text-gray-600">
              "<span className="font-semibold text-gray-800">{query}</span>" için {products.length} sonuç bulundu
            </p>
          )}
        </div>

        {/* Results */}
        {loading ? (
          <div className="text-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
            <p className="text-gray-600 mt-4">Aranıyor...</p>
          </div>
        ) : products.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={handleAddToCart}
              />
            ))}
          </div>
        ) : query ? (
          <div className="text-center py-20">
            <div className="text-gray-400 mb-4">
              <SearchIcon size={64} className="mx-auto" strokeWidth={1} />
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">Sonuç Bulunamadı</h3>
            <p className="text-gray-500">
              "<span className="font-semibold">{query}</span>" için sonuç bulunamadı.
            </p>
            <p className="text-gray-500 mt-2">Lütfen farklı kelimeler deneyin.</p>
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="text-gray-400 mb-4">
              <SearchIcon size={64} className="mx-auto" strokeWidth={1} />
            </div>
            <p className="text-gray-500">Aramak için yukarıdaki arama kutusunu kullanın</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default SearchPage;
